export type ReportSource = 'InspectionReport' | 'DailyServiceReport' | 'ShiftReport' | 'LegacyReport';

const REPORT_SOURCE_TO_PATH: Record<ReportSource, string> = {
    InspectionReport: 'inspection',
    DailyServiceReport: 'daily-service',
    ShiftReport: 'shift',
    LegacyReport: 'legacy',
};

const PATH_TO_REPORT_SOURCE: Record<string, ReportSource> = {
    inspection: 'InspectionReport',
    'daily-service': 'DailyServiceReport',
    shift: 'ShiftReport',
    legacy: 'LegacyReport',
};

export const slugifyReportLabel = (label: string): string => {
    return label
        .toLowerCase()
        .trim()
        .replace(/[()]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '') || 'report';
};

export const reportSourceToPathSegment = (source: string): string => {
    if (source in REPORT_SOURCE_TO_PATH) {
        return REPORT_SOURCE_TO_PATH[source as ReportSource];
    }

    if (source in PATH_TO_REPORT_SOURCE) {
        return source;
    }

    return 'legacy';
};

export const reportPathSegmentToSource = (segment: string): ReportSource => {
    return PATH_TO_REPORT_SOURCE[segment] || 'LegacyReport';
};

export const buildReportPath = ({
    id,
    source,
    slugLabel,
}: {
    id: string;
    source: string;
    slugLabel?: string | null;
}): string => {
    const sourceSegment = reportSourceToPathSegment(source);
    const slug = slugifyReportLabel(slugLabel || 'report');

    return `/report/${sourceSegment}/${slug}/${id}`;
};
